import type { LoginWithPrivyDto } from './auth.dto';
import axios from './index';

/**
 * APIs
 */
// 登录
export function login(data: any) {
    return axios('/v1/login', {
        data,
        method: 'post',
    }).then((res) => res.data);
}

// 登录/注册 - Privy
export function loginWithPrivy(data: LoginWithPrivyDto) {
    return axios('/v1/login/privy', {
        data,
        method: 'post',
    }).then((res) => res.data);
}
